import { useMemo } from 'react'

export const useImgCached = (src: string | undefined) => {
  const isCached = useMemo(() => {
    if (!src) {
      return false
    }

    const img = new Image()
    img.src = src

    return img.complete
  }, [src])

  return isCached
}
